/** Review ticker + floating ATC bar for product page */

function initReviewTicker() {
  const root = document.querySelector("[data-kkh-review-ticker]");
  if (!root) return;

  const slides = [...root.querySelectorAll("[data-review-slide]")];
  const dots = [...root.querySelectorAll("[data-review-dot]")];
  if (slides.length < 2) return;

  let index = 0;
  let timer;

  const show = (next) => {
    slides[index].hidden = true;
    slides[index].classList.remove("is-active");
    dots[index]?.classList.remove("is-active");

    index = next;
    slides[index].hidden = false;
    slides[index].classList.add("is-active");
    dots[index]?.classList.add("is-active");
  };

  const next = () => show((index + 1) % slides.length);

  const restart = () => {
    window.clearInterval(timer);
    timer = window.setInterval(next, 6000);
  };

  dots.forEach((dot, i) => {
    dot.addEventListener("click", () => {
      if (i === index) return;
      show(i);
      restart();
    });
  });

  restart();
}

function parseSize(value) {
  const match = value.match(/^(.+?)\s*\((.+)\)\s*$/);
  if (!match) return value;
  return match[1].trim();
}

function initFloatingAtc() {
  const bar = document.querySelector("[data-kkh-floating-atc]");
  const variantRoot = document.querySelector("variant-radios");
  const buyBlock = document.querySelector(".product-form__add");
  const mainBtn = document.querySelector('.product-form__add-btn[name="add"]');
  const selectionEl = bar?.querySelector("[data-floating-selection]");
  const floatBtn = bar?.querySelector("[data-floating-atc]");

  if (!bar || !variantRoot || !buyBlock || !mainBtn || !selectionEl || !floatBtn) return;

  const updateSelection = () => {
    const size = variantRoot.querySelector('input[name="Size"]:checked')?.value || "";
    const finish = variantRoot.querySelector('input[name="Frame"]:checked')?.value || "";
    const cm = parseSize(size);
    const mainLabel = mainBtn.querySelector("staged-action-text");
    const priceMatch = mainLabel?.textContent?.match(/—\s*(.+)$/);
    const price = priceMatch ? priceMatch[1].trim() : "";

    if (price && cm && finish) {
      selectionEl.innerHTML = `<span class="kkh-floating-atc__price">${price}</span> <span aria-hidden="true">·</span> ${cm} <span aria-hidden="true">·</span> ${finish}`;
    } else {
      selectionEl.textContent = "";
    }

    const soldOut = mainBtn.disabled;
    floatBtn.disabled = soldOut;
    if (soldOut) {
      floatBtn.textContent = "SOLD OUT";
    } else if (price) {
      floatBtn.innerHTML = `ADD TO CART — <span class="kkh-atc-price">${price}</span>`;
    } else {
      floatBtn.textContent = "ADD TO CART";
    }
  };

  const toggle = () => {
    const rect = buyBlock.getBoundingClientRect();
    const past = rect.bottom < 0;
    bar.hidden = !past;
    bar.classList.toggle("is-visible", past);
  };

  floatBtn.addEventListener("click", () => {
    if (mainBtn.disabled) return;
    mainBtn.click();
  });

  variantRoot.addEventListener("change", updateSelection);
  document.addEventListener("variant:changed", updateSelection);

  const observer = new MutationObserver(updateSelection);
  observer.observe(mainBtn.querySelector("staged-action-text") || mainBtn, {
    childList: true,
    characterData: true,
    subtree: true,
  });

  window.addEventListener("scroll", toggle, { passive: true });
  window.addEventListener("resize", toggle, { passive: true });

  updateSelection();
  toggle();
}

function initEditionBox() {
  const root = document.querySelector("[data-kkh-edition-box]");
  const dataEl = document.getElementById("kkh-edition-data");
  const variantRoot = document.querySelector("variant-radios");
  if (!root || !dataEl || !variantRoot) return;

  let data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch {
    return;
  }

  const countEl = root.querySelector("[data-edition-count]");
  const copyEl = root.querySelector("[data-edition-copy]");
  const barEl = root.querySelector("[data-edition-bar]");
  const total = data.total || 50;

  const getSizeKey = (label) => data.labels?.[label] || null;

  const getRemaining = (sizeKey) => {
    if (!sizeKey) return total;
    const remaining = data.sizes?.[sizeKey]?.remaining;
    return typeof remaining === "number" ? remaining : total;
  };

  const update = () => {
    const sizeLabel = variantRoot.querySelector('input[name="Size"]:checked')?.value || "";
    const sizeKey = getSizeKey(sizeLabel);
    const remaining = getRemaining(sizeKey);
    const pct = Math.max(0, Math.min(100, Math.round((remaining / total) * 100)));

    if (countEl) countEl.textContent = String(remaining);
    if (barEl) barEl.style.setProperty("--kkh-pct", `${pct}%`);
    root.classList.toggle("kkh-edition-box--sold-out", remaining === 0);

    if (copyEl) {
      copyEl.textContent =
        remaining === 0
          ? "Sold out at this size. Other sizes may still be available."
          : `of ${total} remain at this size. Numbered edition with certificate of authenticity.`;
    }
  };

  variantRoot.addEventListener("change", update);
  document.addEventListener("variant:changed", update);
  update();
}

function initSizeGuideJump() {
  document.querySelectorAll("[data-kkh-size-guide-jump]").forEach((link) => {
    link.addEventListener("click", (event) => {
      const target = document.getElementById("kkh-size-guide");
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
      window.history.replaceState(null, "", "#kkh-size-guide");
    });
  });
}

function init() {
  initReviewTicker();
  initFloatingAtc();
  initEditionBox();
  initSizeGuideJump();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
